export default "__VITE_ASSET__Bp_GoRdz__"